/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavItem_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNav_viewer$ref: FragmentReference;
export type SiteNav_viewer = {|
  +navigation?: ?{|
    +modules: ?$ReadOnlyArray<?{|
      +serviceId: ?string,
      +$fragmentRefs: SiteNavItem_navigationModule$ref,
    |}>
  |},
  +tradeNavigation?: ?{|
    +modules: ?$ReadOnlyArray<?{|
      +serviceId: ?string,
      +$fragmentRefs: SiteNavItem_navigationModule$ref,
    |}>
  |},
  +$refType: SiteNav_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey",
  "type": "String"
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modules",
    "storageKey": null,
    "args": null,
    "concreteType": "NavigationModule",
    "plural": true,
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "SiteNavItem_navigationModule",
        "args": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "SiteNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "previewKey",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchNav",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchTradeNav",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchTradeNav",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "tradeNavigation",
          "name": "navigation",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "userType",
              "value": "TRADE",
              "type": "globalNavigationuserType"
            }
          ],
          "concreteType": "Navigation",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNav",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "navigation",
          "name": "navigation",
          "storageKey": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "Navigation",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '67f862a1d5c0841169217f3a351d0070';
module.exports = node;
